import { AI2Logo } from './AI2Logo';
import { AI2Mark } from './AI2Mark';
import { ACE } from './ACE';
import { Ai2OLMoE } from './Ai2OLMoE';
import { Ai2OpenScholar8B } from './Ai2OpenScholar8B';
import { Ai2Playground } from './Ai2Playground';
import { DataDecide } from './DataDecide';
import { Dolma } from './Dolma';
import { EarthSystems } from './EarthSystems';
import { Molmo } from './Molmo';
import { OLMES } from './OLMES';
import { OLMo } from './OLMo';
import { OLMoE } from './OLMoE';
import { Paloma } from './Paloma';
import { PixMo } from './PixMo';
import { Playground } from './Playground';
import { SafetyTool } from './SafetyTool';
import { Skiff } from './Skiff';
import { Tulu } from './Tulu';
import { Tulu3 } from './Tulu3';
import { Tulu370B } from './Tulu370B';
import { Tulu3405B } from './Tulu3405B';
import { Varnish } from './Varnish';

export const logos = {
    AI2Logo,
    AI2Mark,
    ACE,
    Ai2OLMoE,
    Ai2OpenScholar8B,
    Ai2Playground,
    DataDecide,
    Dolma,
    EarthSystems,
    Molmo,
    OLMES,
    OLMo,
    OLMoE,
    Paloma,
    PixMo,
    Playground,
    SafetyTool,
    Skiff,
    Tulu,
    Tulu3,
    Tulu370B,
    Tulu3405B,
    Varnish,
};

export default logos;
